<template>
    <div class="evaluation" v-if="evaluation">
        <div class="student" v-if="evaluation.user.checkin">
            <div class="row">
                <div class="col-xs-6">
                    <b>Overall:</b>
                </div>
                <div class="col-xs-6">
                    {{evaluation.user.checkin.overallStatus | capitalize}}
                </div>
            </div>
            <div class="row">
                <div class="col-xs-6">
                    <b>Comments:</b>
                </div>
                <div class="col-xs-6">
                    {{evaluation.user.checkin.overallStatusDetails}}
                </div>
            </div>
            <div class="row" v-if="evaluation.user.checkin.demo_reel_update.demo_r">
                <ul class="files">
                    <li v-for="file in evaluation.user.checkin.demo_reel_update.files">
                        <a :href="file" target="_blank">
                            <img :src="file" v-if="isImage(file)">
                            <img v-else src="../../assets/img/play-button.png">
                        </a>
                    </li>
                </ul>
            </div>
            <demo-reel-feedback v-if="evaluation.user.checkin
                                    && evaluation.user.checkin.demo_reel_update
                                    && !evaluation.user.checkin.demo_reel_update.demo_r"
                                    :checkin="evaluation.user.checkin">
            </demo-reel-feedback>
        </div>



        <div v-if="evaluation.reasonMissed" class="form-group">
            <label class="heading">We see you missed your meeting this week with {{evaluation.user.firstName}} {{evaluation.user.lastName}}, what happened?</label>
            <div class="textarea-wrapper">
                <textarea readonly class="form-control" v-model="evaluation.reasonMissed">
                </textarea>
            </div>
        </div>

        <div v-else class="form-group">
            <label class="heading">How was your mentorship session in relation to {{evaluation.user.firstName}} {{evaluation.user.lastName}}?</label>
            <div class="radio-wrapper">
                <div v-for="status in statuses">
                    <label>
                        <span class="dot" :class="{'selected':status.value === evaluation.participation}"></span>
                        {{status.label}}
                    </label>
                </div>
            </div>

            <div class="form-group">
                 <label class="heading">Please share a few words about how your mentorship session went and what was covered in relation to {{evaluation.user.firstName}} {{evaluation.user.lastName}}.</label>             

                 <div class="textarea-wrapper">
                     <textarea
                         readonly
                         class="form-control"
                         :value="evaluation.sessionComments">
                     </textarea>
                 </div>
            </div>

        </div>
        <div class="form-group">
            <label class="heading">How is {{evaluation.user.firstName}} {{evaluation.user.lastName}}'s progress this week?</label>
            <div class="radio-wrapper">
                <div v-for="status in statuses">
                    <label>
                        <span class="dot" :class="{'selected':status.value === evaluation.progress}"></span>
                        {{status.label}}
                    </label>
                </div>
            </div>
        </div>
        <div class="form-group">
             <label class="heading">Please share a few words about {{evaluation.user.firstName}} {{evaluation.user.lastName}}'s progress this week, including how they're progressing and what they're working on.</label>             

             <div class="textarea-wrapper">
                 <textarea
                     readonly
                     class="form-control"
                     :value="evaluation.comments">
                 </textarea>
             </div>
        </div>


        <div class="submission-date">
            Submitted on {{ formatFullDate(evaluation.updatedAt) }}
        </div>
    </div>
</template>
<script>

import moment from 'moment';

import DemoReelFeedback from './DemoReelFeedback';

export default {
    props: ['checkin', 'studentId', 'statuses'],
    data() {
        return {
            evaluation: null,
        }
    },
    components: {
        DemoReelFeedback
    },
    mounted() {
        this.evaluation = this.checkin.checkin.weekly_evaluations.find((e) => { return e.studentId === this.studentId });
    },

    methods: {
        formatFullDate(date) {
            return moment.tz(date, 'America/Vancouver').format('MMM D, YYYY [at] h:mma');
        },

    },
}

</script>
<style lang="scss" scoped>
.dot {
    width: 14px;
    height: 14px;
    border: 1px solid #b0b0b0;
    border-radius: 50%;
    display: inline-block;
    cursor: pointer;
    position: relative;
    top: 2px;
    margin-right: .5rem;

    &.selected {
        background: #33ccff;
        border-color: #33ccff;
    }
}

.radio-wrapper {
    margin: 6px 0 20px 20px;

    input {
        display: none;
    }

    input:checked+.dot {
        background: #b0b0b0;
    }
}

.textarea-wrapper {
    width: 100%;
    max-width: 600px;
    margin: 10px 0 25px;
    padding: 0 0 0 20px;
}

textarea.form-control {
    background: #222 !important;
    //max-width: 400px;
    height: 8rem;
    border: none !important;
    padding: 1rem !important;
    &::-webkit-scrollbar {
        width: 10px;
    }
    &::scrollbar {
        width: 10px;
    }
}

.submission-date {
    font-style: italic;
    color: #777;
    margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// WeeklyEvaluation.vue?0d5d440a